import {
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styles from "../styles";
import '../components/styles.css';
import BiomarkersDialog from "./BiomarkersDialog";

const useStyles = makeStyles((theme) => styles(theme));

export default function LabPackageCard({ _package }) {

  console.log(_package, "_package")
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));
  const [bioMarkersDialog, setBioMarkesDialog] = useState(false);

  const savedCity = useSelector((state) =>
    state.city !== undefined && state.city.label !== undefined ? state.city : ""
  );

  const savedArea = useSelector((state) =>
    state.area !== undefined && state.area.area !== undefined
      ? state.area.area
      : ""
  );

  const doComparison = () => {
    if (savedArea && savedCity) {
      if (_package.uuid) {
        history.push({
          pathname: `/lab-package-compareprices/${_package.uuid}`,
          //   search: _package.uuid,
          state: { packageId: _package.uuid },
        });
      }
    } else {
      alert("Select Address");
    }
  };

  const NumberofLines = _package?.package_description?.slice(0, 75)
  
  return (
    <>
      <Card>
        <CardContent>
          <Grid container direction="column" alignItems="center">
            <Typography
              style={{ color: "#00839B", height: "50px" }}
              align="center"
            >
              {`${_package.panel_name}`}
            </Typography>
            <Typography className={classes.productTitle} gutterBottom>
              {`(${_package.package_type})`}
            </Typography>
            <Typography variant="body1" align="center" gutterBottom
              // className={classes.PackageDescription} 
              className={(NumberofLines?.length < 75) ? "" : "ScrollButtton ::-webkit-scrollbar ::-webkit-scrollbar-track ::-webkit-scrollbar-thumb"}
            // style={{
            //   overflow:"scroll",
            //   overflowX:"hidden",
            //   height:"11vh"
            // }}
            >
              {_package.package_description}
            </Typography>
            <Grid
              item
              xs={12}
              className={classes.titleContainer}
              style={{
                padding: "8px",
                cursor: "pointer",
                backgroundColor: "#FEF0C7",
                marginTop: "20px",
              }}
              onClick={() => setBioMarkesDialog(!bioMarkersDialog)}
            >
              <Typography
                variant="h6"
                align="center"
                style={{
                  color: "#00839B",
                  fontWeight: "500",
                }}
              >
                {"Investigation areas : " + _package.no_of_investigation_area}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              className={classes.titleContainer}
              style={{ padding: "8px", cursor: "pointer" }}
              onClick={() => setBioMarkesDialog(!bioMarkersDialog)}
            >
              <Typography
                variant="h6"
                align="center"
                style={{
                  color: "#00839B",
                  fontWeight: "500",
                }}
              >
                {"Biomarkers : " + _package.no_of_biomarks}
              </Typography>
            </Grid>
            <Grid item style={{ marginBottom: "20px" }} xs={12}>
              <Typography align="center" variant="body1">
                Start from
              </Typography>
              <Typography
                align="center"
                variant="h5"
                style={{ fontWeight: "900", color: "#002931" }}
              >
                ₦ {_package.min_amount}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                className={classes.viewTestButton}
                onClick={doComparison}
              >
                Compare Prices
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card >
      <BiomarkersDialog
        show={bioMarkersDialog}
        hide={() => setBioMarkesDialog(!bioMarkersDialog)}
        _packageData={_package}
        type={""}
      />
    </>
  );
}
